export const module = {
  info: {
    name: 'voip-destination-sms-side-menu',
    caption: 'voip destination sms side menu',
    viewGroup: 'fasfreeroute-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Destinations SMS',
    icon: 'el-icon-top-right',
    routeName: 'module->voip-destination-sms->list->page',
    routeParams: { listPage: 1},
    children: [
      {
        caption: 'Add Working Destination',
        icon: 'el-icon-plus',
        routeName: 'module->voip-destination-sms->add-working-destination'
      },
      {
        caption: 'Reset Destination',
        icon: 'el-icon-refresh',
        routeName: 'module->voip-destination-sms->reset-destination'
      },
      {
        caption: 'List',
        icon: 'el-icon-top-right',
        routeName: 'module->voip-destination-sms->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
